<form [formGroup]="convert_to_eform_settings" *ngIf="convert_to_eform_settings && eform_steps">
    <div class="e-form-steps-wrapper">
        <ul class="nav" formArrayName="eform_steps">
            @for (step of eform_steps?.controls; track step; let i = $index) {
                <li class="nav-item d-flex eform-step-li justify-content-between align-items-center" (click)="onStepChange(step.value)" formGroupName="{{i}}">
                    <div class="e-form-icon border cursor-pointer py-50 me-50" [ngClass]="{'fill': step.value.key === currentStep}" [ngStyle]="{'background-color': (step.value.key === currentStep ? convert_to_eform_settings.get('brand_color').value : '')}">
                        <span class="px-1">{{(i+1)}}</span>
                    </div>
                    <div class="eform-link-text text-truncate">
                        <a class="nav-link pb-0 pt-25 text-black eform-title-icon-hover text-truncate" href="javascript:void(0)" [ngClass]="{'active': step.value.key === currentStep}">
                            @if(step.value.editingHeading){
                                <input type="text" [value]="step.value.heading" class="eform-steps-input form-control" (blur)="editStepHeading($event, 'heading', i, true)" formControlName="heading" [id]="i+'-heading'" ondrop="return false;">
                            }@else{
                                                          
                                @if(step.value?.heading?.trim()?.length > 0){
                                        {{step.value?.heading }}
                                   }@else if(step?.value?.key) {
                                       {{stepsTranslation[step.value.key]?.heading  | dynamicLanguage | async }}
                                   }
                            }
                            @if(!hideEditIcon){
                                <span class="eform-title-edit-icon ms-50 cursor-pointer" (click)="editStepHeading($event, 'heading', i)">
                                    <i data-feather="edit-3" [size]="12"></i>
                                </span>
                            }
                        </a>
                        <small class="px-50 text-muted text-truncate eform-subtitle-icon-hover d-block">
                            @if(step.value.editingSubheading){
                                <input type="text" [value]="step.value.subheading" class="eform-steps-subtile-input eform-steps-input form-control" (blur)="editStepHeading($event, 'subheading', i, true)" formControlName="subheading" [id]="i+'-subheading'" ondrop="return false;">
                            }@else{

                                @if(step.value?.subheading?.trim()?.length > 0){
                                        {{step.value.subheading }}
                                   }@else if(step?.value?.key) {
                                       {{stepsTranslation[step.value.key]?.subheading  | dynamicLanguage | async }}
                                   }
                            }
                            @if(!hideEditIcon){
                                <span class="eform-subtitle-edit-icon ms-50 cursor-pointer" (click)="editStepHeading($event, 'subheading', i)">
                                    <i data-feather="edit-3" [size]="12"></i>
                                </span>
                            }
                        </small>
                    </div>
                    <div class="e-form-arrow me-2 ms-1">
                        <i data-feather="chevron-right" [size]="18"></i>
                    </div>
                </li>
            }
        </ul>
    </div>
</form>